// @ts-nocheck
import { Overlay } from '@angular/cdk/overlay';
import { NgStyle, NgTemplateOutlet } from '@angular/common';
import { Component, ElementRef, inject } from '@angular/core';
import { IconComponent } from '@lbca-shared/icon';
import { FormTemplateService } from '../../dynamic-form/sub-modules/form-template/form-template.service';
import { InputTextComponent } from '../input-text/input-text.component';

@Component({
  selector: 'lbca-input-process-number',
  templateUrl: '../input-text/input-text.component.html',
  styleUrl: './../input-text/input-text.component.scss',
  imports: [IconComponent, NgTemplateOutlet, NgStyle],
})
export class InputProcessNumberComponent extends InputTextComponent {
  override overlay: Overlay;
  formTemplateService = inject(FormTemplateService);

  constructor() {
    const overlay = inject(Overlay);
    const elementRef = inject(ElementRef);

    super(overlay, elementRef);

    this.overlay = overlay;
  }

  public override async focusOut() {
    this.searchProcessNumber(this.formatedValue);
    await super.focusOut();
  }

  public override focusIn(): void {
    this.helperTextValue = '';
    super.focusIn();
  }

  searchProcessNumber(value: string) {
    const extraFields: any = [
      {
        value: value,
        type: 'array',
        key: ['cnj.keyword', 'process_number.keyword', 'processNumber.keyword'],
        label: 'Número do Processo/cnj',
      },
    ];

    const queryStringParameters = {
      idx: 'process',
      returnFields: JSON.stringify(['*']),
      sourceFields: JSON.stringify(['*']),
      page: 0,
      size: '10',
      sort: JSON.stringify(['id.keyword']),
      extraFields: JSON.stringify(extraFields),
      capabilityName: 'base/home',
    };

    this.formTemplateService
      .getDinamicUrl('/search/query', queryStringParameters)
      .subscribe((body: any) => {
        if (body.total > 0) {
          this.helperTextValue = `Já existe um caso cadastrado na base com o mesmo número de processo.`;
        }
      });
  }
}
